import type { RecipeProps } from '~/types/crafting';
import { RecipeType } from '~/utils/constants';
import { capitalize } from 'element-plus/es/utils/strings';
import { useI18n } from '#imports';

const speedPrefixTypes = {
  en: ['fast', 'super'],
  ru: ['быстр', 'сверх'],
  de: ['schnelle', 'super']
};

export function getCleanRecipeName(recipe: RecipeProps, recipeIdPrefix: string): string {
  const { t, locale } = useI18n();

  const name = t(`${recipeIdPrefix}${recipe?.recipeId}`);
  const lang = locale.value as keyof typeof speedPrefixTypes;
  const speedPrefixType = speedPrefixTypes[lang];

  const cleanedName = name
    .split(' ')
    .filter((word) => !speedPrefixType.some((prefix) => word.toLowerCase().includes(prefix)))
    .join(' ');

  return capitalize(cleanedName);
}

export function getRecipeSpeedLevel(recipe: RecipeProps, recipeIdPrefix: string): number {
  const { t } = useI18n();
  const recipeNameEN = t(`${recipeIdPrefix}${recipe?.recipeId}`, {}, { locale: 'en' }).toLowerCase();

  if (recipeNameEN.includes(RecipeType.SUPERFAST)) return 2;
  if (recipeNameEN.includes(RecipeType.FAST)) return 1;
  return 0;
}
